import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  href?: string;
  linkText?: string;
}

export default function SectionHeading({ title, subtitle, href, linkText }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="min-w-0">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">{title}</h2>
        {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {href && (
        <Link
          to={href}
          className="flex items-center gap-1 shrink-0 text-sm font-label text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          {linkText ?? "查看更多"}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}